export default __webpack_public_path__ + "static/media/YAS0080.34I-27549_-16539_0.eef69410.jpg";